/** token信息常量，缓存到localstorage中，是一个对象*/
export const _TOKEN = 'platformTokenInfo';
/** 登陆页面的url，缓存到localstorage中*/
export const _LOGIN_URL = 'redirectLoginUrl';


/** 海量保host，用于需要定制时的条件判断*/
// 最新使用的是 hailiangbao.520haibao.com
// 如果需要修改海量保域名，闪电核项目页需要同步兼容
export const _HLB_HOST = ['hailiangbao.520haibao.com', '51chudan.520haibao.com']; // 不要添加http协议

// 定制化登录页商户列表，根据url中的orgId来判断展示哪个
export const CUSTOMIZED_MERCHANT_LIST = [{
  preBgUrl: 'https://oss.zhongbaounion.com/share/background/yjb_bg1_pre.jpg',
  bgURl: 'https://oss.zhongbaounion.com/share/background/yjb_bg1.jpg',
  descUrl: 'https://oss.zhongbaounion.com/share/background/yjb_login_bg_desc.png',
  merchantBelong: 'yjb'
}]


// 定制化开通开放平台入口的一级机构companyId列表
export const CUSTOMIZED_FIRST_LEVEL_COMPANY_ID_LIST = [
  '1506915693280739328', // 测试环境
  '1547562419866193920', // 生产测试
  '1552202251473178624', // 生产客户
  '1592799173515485184', // 晓伟1125让新加的
  '1547565060952313856', //晨阳23-10/27添加
  '1717531072725221376',//晨阳23-10/27添加
  '1820349675300204544',//晓伟24-8/20添加
]
